import { Table } from '@zoom/zoom-ui';
import Vue from 'vue';

const TableComponent = Vue.extend(Table);

export default TableComponent.extend({
  name: 'SelectionTable',
  props: {
    initSelections: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.initSelections.forEach(item => {
      this.toggleRowSelection(item);
    });
  },
});
